export const ALGORITHM_PANEL_CHANGE = 'ALGORITHM_PANEL_CHANGE';
export const RESET_ALGORITHM_PANEL = 'RESET_ALGORITHM_PANEL';

export interface payloadAlgorithmPanel {
    type: string;
    width?: number;
    height?: number;
    size?: number;
    extrusion: number;
    separation: number;
}

export interface actionAlgorithmPanel {
    type: string;
    payload: payloadAlgorithmPanel;
}

export const actionAlgorithmPanel = (payload: payloadAlgorithmPanel): actionAlgorithmPanel => {
    return {
        type: ALGORITHM_PANEL_CHANGE,
        payload,
    };
};

export const ResetAlgorithmAction = () => {
    return {
        type: RESET_ALGORITHM_PANEL,
    };
};
